import z, { ZodSchema } from 'zod';

export default <T>(itemSchema: ZodSchema<T>) =>
  z.object({
    items: z.array(itemSchema),
    hasNextPage: z.boolean(),
    hasPreviousPage: z.boolean(),
    pageNumber: z.number(),
    pageSize: z.number(),
    totalItems: z.number(),
    totalPages: z.number(),
  });
